import React from 'react'
import { useState, useEffect, useRef, useMemo, useCallback } from 'react'
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import AssignedAds from "./AssignedAds";
import ProgressAds from "./ProgressAds";
import CompleteAds from "./CompleteAds";
import AbortAds from './AbortAds';
import { useTableState } from './utils/useTableState';
import api from "../../services/api";
import config from "../../config";
import { Toast } from "../../shared/Toast";
import { registerSW } from '../../utils/pushSubscription';
import FilterBar from './components/FilterBar.js';
import {  EmitEvent } from '../../services/socket';
import { ChatProvider, useChatContext } from '../../context/ChatContext';
import ChatPanel from './components/ChatPanel';

const types = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "full_page",
    label: "Full Image",
  },
  {
    value: "full_video",
    label: "Full Video",
  },
  {
      value:"half_video",
      label:"Half Video"
  },
  {
    value: "promoted_image_story",
    label: "Promoted Image Story ",
  },
]

const HomeInner = () => {

  const { closeChat } = useChatContext();
  const [loader,setloader] = useState(false);

  const { currentPage, setCurrentPage, handlePageChange, salesList,getSalesList } = useTableState();
  // shared filter state lifted from children
  // const today = new Date().toISOString().split('T')[0];
  // const tomorrow = new Date();
  // tomorrow.setDate(tomorrow.getDate() + 1);
  // const tomorrowStr = tomorrow.toISOString().split('T')[0];
  const [dateRange, setDateRange] = useState({startDate:null,endDate:null});
  const dateRangeRef = useRef(dateRange);

  const [adType, setAdType] = useState(null);
  const [search, setSearch] = useState('');
  const adTypeRef = useRef(adType);
  const searchRef = useRef(search);

  const [sortByLatestMessage, setSortByLatestMessage] = useState(() => {
    const saved = localStorage.getItem('view_designer_by_latest_message');
    return saved ? JSON.parse(saved) : false;
  });
  const sortByLatestMessageRef = useRef(sortByLatestMessage);

  const [currentChild, setcurrentChild] = useState('assigned-Ads');

  const [assignedDesigns, setassignedDesigns] = useState([]);
  const [totalassigned, settotalassigned] = useState(0);
  const [assignedHasMore, setAssignedHasMore] = useState(false);

  const [progressDesigns, setprogressDesigns] = useState([]);
  const [totalprogress, settotalprogress] = useState(0);
  const [initialcount, setinitialcount] = useState(0);
  const [rejectedcount, setrejectedcount] = useState(0);
  const [progressseletedtab, setprogressseletedtab] = useState('initial');
  const [progressHasMore, setProgressHasMore] = useState(false);

  const [completeDesigns, setcompleteDesigns] = useState([]);
  const [totalcomplete, settotalcomplete] = useState(0);
  const [NotAcceptedCount, setnotacceptedcount] = useState(0);
  const [AcceptedCount, setacceptedcount] = useState(0);
  const [completeselectedtab, setcompleteselectedtab] = useState('Pending_Approval');
  const [completeHasMore, setCompleteHasMore] = useState(false);

  const [abortDesigns, setabortDesigns] = useState([]);
  const [totalabort, settotalabort] = useState(0);
  const [abortHasMore, setAbortHasMore] = useState(false);

  const tabGroupRef = useRef(null);

  const handleTabSwitch = (panelName) => {
    // const today = new Date().toISOString().split('T')[0];
    // const tomorrow = new Date();
    // tomorrow.setDate(tomorrow.getDate() + 1);
    // const tomorrowStr = tomorrow.toISOString().split('T')[0];
    setDateRange({startDate:null,endDate:null});
    setAdType(null);
    setSearch('');
    tabGroupRef.current?.show(panelName);
  };

  // now accepts filters
  const getassignedDesigns = async (page, dateRange, adType, search, append = false) => {
    try {
      setloader(true);
      let res = await api({
        url: `/user/designer/getAssignedDesignes`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || '',
          sort_by_latest_message: sortByLatestMessageRef.current
        }
      });
      if (res.code === 200) {
        const newData = res.data?.data || [];
        const total = res.data?.total || totalassigned;
        if (append) setassignedDesigns(prev => [...prev, ...newData]);
        else setassignedDesigns(newData);
        setAssignedHasMore((page + 1) < Math.ceil(total / config.PER_PAGE));
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
  const totalCount = async(dateRange,search,adType)=>{
    try {
      let res = await api({
        url: `/user/designer/getTotalCount`,
        method: "POST",
        responseType: "json",
        data: {
          start_date: dateRange?.startDate || null,
          end_date: dateRange?.endDate || null,
          ad_type: adType?.value || null,
          query: search || ''
        }
      });
      if (res.code === 200) {
        settotalassigned(res.data.find(item => item.status === 2)?.total);
        const progress = res.data
        .filter(item => item.status === 3)
        .reduce((sum, item) => sum + Number(item.total), 0);
        settotalprogress(progress);

        setnotacceptedcount(res.data.find(item => item.status === 4)?.total ?? 0);
        const accepted = res.data.filter(item => item.status >= 6).reduce((sum,item)=>sum + Number(item.total),0);
        setacceptedcount(accepted);

      const complete = res.data
        .filter(item => item.status === 4 || item.status >= 6)
        .reduce((sum, item) => sum + Number(item.total), 0);
      settotalcomplete(complete);

      setinitialcount(res.data.find(item => item.status == "initial")?.total);
      setrejectedcount(res.data.find(item=>item.status == "rejected")?.total);
      settotalabort(res.data.find(item => item.status === "abort")?.total);
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  
  useEffect(() => {
    dateRangeRef.current = dateRange;
    searchRef.current = search;
    adTypeRef.current = adType;
    sortByLatestMessageRef.current = sortByLatestMessage;
  }, [dateRange,adType,search,sortByLatestMessage]);

  useEffect(() => {
    localStorage.setItem('view_designer_by_latest_message', JSON.stringify(sortByLatestMessage));
  }, [sortByLatestMessage]);

  useEffect(() => {
    registerSW();
    const interval = setInterval(() => {
      totalCount(dateRangeRef.current,searchRef.current,adTypeRef.current); // always latest value
    }, 10000);
  
    return () => clearInterval(interval);
  }, []); 

  const pickDesign = async (creative_id) => {
    try {
      let res = await api({
        url: `/user/designer/pickDesign`,
        method: "POST",
        responseType: "json",
        data: {
          creative_id
        }
      });
      if (res.code === 200) {
        EmitEvent(creative_id,res.data?.log[0])
        Toast('success',"Design picked successfully");
        handleTabSwitch('progress-Ads')
      }
    }
    catch (error) {
      console.error(error);
    }
  }
  // now accepts filters for server‐side filtering
  const getprogressDesigns = async (page, dateRange, adType, search, append = false) => {
    try {
      setloader(true);
      const url = progressseletedtab === 'initial'
        ? `/user/designer/getProgressDesignes`
        : `/user/designer/getRejectedDesigns`;
      let res = await api({
        url,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || '',
          sort_by_latest_message: sortByLatestMessageRef.current
        }
      });
      if (res.code === 200) {
        const newData = res.data?.data || [];
        const total = res.data?.total || totalprogress;
        if (append) setprogressDesigns(prev => [...prev, ...newData]);
        else setprogressDesigns(newData);
        setProgressHasMore((page + 1) < Math.ceil(total / config.PER_PAGE));
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
  // now accepts filters
  const getcompletedDesigns = async (page, dateRange, adType, search, append = false) => {
    try {
      setloader(true);
      const url = completeselectedtab === 'Pending_Approval'
        ? `/user/designer/getClientNotAcceptedDesigns`
        : `/user/designer/getCompletedDesignes`;
      let res = await api({
        url,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || '',
          sort_by_latest_message: sortByLatestMessageRef.current
        }
      });
      if (res.code === 200) {
        const newData = res.data?.data || [];
        const total = res.data?.total || totalcomplete;
        if (append) setcompleteDesigns(prev => [...prev, ...newData]);
        else setcompleteDesigns(newData);
        setCompleteHasMore((page + 1) < Math.ceil(total / config.PER_PAGE));
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
  // now accepts filters
  const getAbortedDesigns = async (page, dateRange, adType, search, append = false) => {
    try {
      setloader(true);
      let res = await api({
        url: `/user/designer/getAbortedDesigns`,
        method: "POST",
        responseType: "json",
        data: {
          page,
          limit: config.PER_PAGE,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate,
          ad_type: adType?.value || null,
          query: search || '',
          sort_by_latest_message: sortByLatestMessageRef.current
        }
      });
      if (res.code === 200) {
        const newData = res.data?.data || [];
        const total = res.data?.total || totalabort;
        if (append) setabortDesigns(prev => [...prev, ...newData]);
        else setabortDesigns(newData);
        setAbortHasMore((page + 1) < Math.ceil(total / config.PER_PAGE));
      }
      setloader(false);
    } catch (error) {
      console.error(error);
    }
  }
    const handleDateChange = (val) => {
    setDateRange(val);
    setCurrentPage(0);
    closeChat();
  };
  const handleAdTypeChange = (val) => {
    setAdType(val);
    setCurrentPage(0);
    closeChat();
  };
  const handleSearchChange = (value) => {
    setSearch(value);
    setCurrentPage(0);
    closeChat();
  };
  const handleSortByLatestMessageChange = (value) => {
    setSortByLatestMessage(value);
    setCurrentPage(0);
    closeChat();
  };
  // Reset and fetch on filter/tab change (no append)
  useEffect(() => {
    totalCount(dateRange, search, adType);
    setCurrentPage(0);
    if (currentChild === 'assigned-Ads') {
      setassignedDesigns([]);
      getassignedDesigns(0, dateRange, adType, search, false);
    } else if (currentChild === 'progress-Ads') {
      setprogressDesigns([]);
      getprogressDesigns(0, dateRange, adType, search, false);
    } else if (currentChild === 'complete-Ads') {
      setcompleteDesigns([]);
      getcompletedDesigns(0, dateRange, adType, search, false);
    } else {
      setabortDesigns([]);
      getAbortedDesigns(0, dateRange, adType, search, false);
    }
  }, [currentChild, dateRange, adType, search, progressseletedtab, completeselectedtab, sortByLatestMessage]);

  const homeLoadMoreCtx = useRef({});
  homeLoadMoreCtx.current = { loader, currentPage, currentChild, dateRange, adType, search, assignedHasMore, progressHasMore, completeHasMore, abortHasMore };

  const handleHomeLoadMore = useCallback(() => {
    const ctx = homeLoadMoreCtx.current;
    if (ctx.loader) return;
    const nextPage = ctx.currentPage + 1;
    setCurrentPage(nextPage);
    if (ctx.currentChild === 'assigned-Ads' && ctx.assignedHasMore)
      getassignedDesigns(nextPage, ctx.dateRange, ctx.adType, ctx.search, true);
    else if (ctx.currentChild === 'progress-Ads' && ctx.progressHasMore)
      getprogressDesigns(nextPage, ctx.dateRange, ctx.adType, ctx.search, true);
    else if (ctx.currentChild === 'complete-Ads' && ctx.completeHasMore)
      getcompletedDesigns(nextPage, ctx.dateRange, ctx.adType, ctx.search, true);
    else if (ctx.abortHasMore)
      getAbortedDesigns(nextPage, ctx.dateRange, ctx.adType, ctx.search, true);
  }, []);
 
  return (
    <div style={{ padding: '20px' }}>
      <SlTabGroup
        ref={tabGroupRef} 
        onSlTabShow={(event) => {
          const panelName = event.detail.name;
          setcurrentChild(panelName);
          // const today = new Date().toISOString().split('T')[0];
          // const tomorrow = new Date();
          // tomorrow.setDate(tomorrow.getDate() + 1);
          // const tomorrowStr = tomorrow.toISOString().split('T')[0];
          setDateRange({startDate:null,endDate:null});
          setAdType(null);
          setSearch('');
          closeChat();
        }}>
        <SlTab slot="nav" panel="assigned-Ads">Assigned Designs <span className='text-blue-600 mx-1'> {totalassigned || 0} </span></SlTab>
        <SlTab slot="nav" panel="progress-Ads">Progress Designs <span className='text-blue-600 mx-1'> {totalprogress || 0}</span></SlTab>
        <SlTab slot="nav" panel="complete-Ads">Complete Designs <span className='text-blue-600 mx-1'> {totalcomplete || 0}</span></SlTab>
        <SlTab slot="nav" panel="abort-Ads">Abort Designs <span className='text-blue-600 mx-1'>{totalabort || 0}</span></SlTab>
        <div className="flex flex-wrap gap-4 m-4 items-end">
        <FilterBar
          dateRange={dateRange}
          onDateChange={handleDateChange}
          adType={adType}
          onAdTypeChange={handleAdTypeChange}
          adTypeOptions={types}
          search={search}
          onSearchChange={handleSearchChange}
          showDesigner={false}
          showStatus={false}
          showSalesPerson={false}
          sortByLatestMessage={sortByLatestMessage}
          onSortByLatestMessageChange={handleSortByLatestMessageChange}
          showSortByLatestMessage={true}
        />
        </div>
        <SlTabPanel name="assigned-Ads">
          <AssignedAds
            pickDesign={pickDesign}
            assignedDesigns={assignedDesigns}
            getassignedDesigns={getassignedDesigns}
            setassignedDesigns={setassignedDesigns}
            totalassigned={totalassigned}
            settotalassigned={settotalassigned}
            activechild={currentChild}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader={loader}
            hasMore={assignedHasMore}
            onLoadMore={handleHomeLoadMore}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
        <SlTabPanel name="progress-Ads">
          <ProgressAds
            getprogressDesigns={getprogressDesigns}
            progressDesigns={progressDesigns}
            setprogressDesigns={setprogressDesigns}
            totalprogress={totalprogress}
            settotalprogress={settotalprogress}
            activechild={currentChild}
            loader={loader}
            tabswitch={handleTabSwitch}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            progressseletedtab={progressseletedtab}
            setprogressseletedtab={setprogressseletedtab}
            initialcount={initialcount}
            rejectedcount={rejectedcount}
            hasMore={progressHasMore}
            onLoadMore={handleHomeLoadMore}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
        <SlTabPanel name="complete-Ads">
          <CompleteAds
            getcompletedDesigns={getcompletedDesigns}
            completeDesigns={completeDesigns}
            setcompleteDesigns={setcompleteDesigns}
            totalcomplete={totalcomplete}
            settotalcomplete={settotalcomplete}
            activechild={currentChild}
            loader={loader}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            completeselectedtab={completeselectedtab}
            setcompleteselectedtab={setcompleteselectedtab}
            NotAcceptedCount={NotAcceptedCount}
            AcceptedCount={AcceptedCount}
            hasMore={completeHasMore}
            onLoadMore={handleHomeLoadMore}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
        <SlTabPanel name="abort-Ads">
          <AbortAds
            abortDesigns={abortDesigns}
            getAbortedDesigns={getAbortedDesigns}
            getassignedDesigns={getassignedDesigns}
            setabortDesigns={setabortDesigns}
            totalabort={totalabort}
            settotalabort={settotalabort}
            activechild={currentChild}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            loader={loader}
            hasMore={abortHasMore}
            onLoadMore={handleHomeLoadMore}
            dateRange={dateRange}
            setDateRange={setDateRange}
            adType={adType}
            setAdType={setAdType}
            search={search}
            setSearch={setSearch}
          />
        </SlTabPanel>
      </SlTabGroup>
      <ChatPanel />
    </div>
  )
}

const Home = () => (
  <ChatProvider>
    <HomeInner />
  </ChatProvider>
);

export default Home